import React, { useContext, useEffect, useMemo, useState } from 'react';
import './_styles.scss'
import './_styles.dark-mode.scss'
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Grid } from 'react-bootstrap';
import qs from 'qs';
import { AppearanceContext } from '../../index';
import { getErrorMessage } from '../../../../utils/helper';
import AlertComponent from '../../../../components/Alert';
import PageNotFound from '../../../404';
import {
  themesFilesList, themesFilesReset,
  themesFilesSave,
  themesFilesView,
} from '../../../../services/endpoints/themes';
import TwigFilesList from './components/FilesList';
import { routesAppearance } from '../../helpers';
import TwigFileCode from './components/FileCode';
import ModalsManager from './components/Modals/Manager';
import Loader from '../../../../components/Loaders/Loader';

const EditTwig = () => {
  const history = useHistory();
  const location = useLocation();

  const { config } = useContext(AppearanceContext);

  const queryString = qs.parse(location.search.slice(1));
  const editRoute = useMemo(() => routesAppearance.find((route) => route.code === 'file-edit'), [])
  const themesRoute = useMemo(() => routesAppearance.find((route) => route.code === 'themes'), [])
  const isEditTheme = location.pathname === editRoute.link || location.pathname === `${editRoute.link}/`;

  const [init, setInit] = useState(false);
  const [data, setData] = useState({
    files: {},
    file: {},
    access: {
      reset: false,
    },
    theme: {},
  });
  const [content, setContent] = useState('');
  const [error, setError] = useState(null)
  const [errorForm, setErrorForm] = useState(null)
  const [isLoading, setIsLoading] = useState({ page: true, form: true, modalSubmit: false });
  const [isFullScreen, setFullScreen] = useState(false);
  const [openModal, setOpenModal] = useState('');
  const [modalData, setModalData] = useState({});

  const { files, file, theme, access } = data;

  const onFullScreen = () => {
    setFullScreen((prevState) => !prevState);
  }

  const onBack = () => {
    history.push(themesRoute.link)
  }

  const fetchFile = async () => {
    setIsLoading((prevState) => ({ ...prevState, form: true }));
    setErrorForm(null);
    try {
      if (!queryString?.name) {
        throw new Error('File name is empty')
      }

      const response = await themesFilesView(queryString?.theme_id, queryString?.name);
      if (response.success) {
        setData((prevState) => ({
          ...prevState,
          ...response.data,
        }));
        setContent(response.data.file.content)
      }

      setIsLoading((prevState) => ({ ...prevState, form: false }));
      return response.data;
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setError(errorMessage);
      setIsLoading((prevState) => ({ ...prevState, form: false }));
    }
  };
  const fetchList = async () => {
    setIsLoading((prevState) => ({ ...prevState, form: true }));
    try {
      if (!queryString?.theme_id) {
        throw new Error('Theme id is empty')
      }
      /**
       * Загружаем список файлов темы
       */
      const response = await themesFilesList(queryString?.theme_id);
      if (response.success) {
        setData((prevState) => ({
          ...prevState,
          files: response.data.files,
          theme: response.data.theme,
        }));
      }

      setIsLoading((prevState) => ({ ...prevState, form: false }));
      return response.data;
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setError(errorMessage);
      setIsLoading((prevState) => ({ ...prevState, form: false }));
    }
  };
  const getAllData = async () => {
    setIsLoading((prevState) => ({ ...prevState, page: true }));

    try {
      if (config?.access?.themes_files_view) {
        await fetchList(queryString);
        if (isEditTheme) {
          await fetchFile()
        }
        setIsLoading((prevState) => ({ ...prevState, page: false }));
      } else {
        setIsLoading((prevState) => ({ ...prevState, page: false }));
      }
      setInit(true);
    } catch (error) {
      setIsLoading((prevState) => ({ ...prevState, page: false }));
    }
  }

  const onSaveChanges = async () => {
    setIsLoading((prevState) => ({ ...prevState, page: true }));
    try {
      const response = await themesFilesSave(queryString?.theme_id, file.filename, content);
      if (response.success) {
        getAllData()
      }
      return response.data;
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setErrorForm(errorMessage);
      setIsLoading((prevState) => ({ ...prevState, page: false }));
    }
  }

  const onHideModals = () => {
    setOpenModal('');
    setModalData({});
  };

  const onResetConfirm = async () => {
    setIsLoading((prevState) => ({ ...prevState, modalSubmit: true }));
    try {
      await themesFilesReset(queryString?.theme_id, queryString?.name)
      setIsLoading((prevState) => ({ ...prevState, modalSubmit: false }));
      getAllData()
      onHideModals('');
    } catch (error) {
      setIsLoading((prevState) => ({ ...prevState, modalSubmit: false }));
    }
  }

  const onSubmitModal = async () => {
    switch (modalData?.actionType) {
    case 'single':
      if (modalData?.title === 'Reset file') {
        await onResetConfirm()
      }
      break;

    default:
      break;
    }
  };

  const onReset = (e) => {
    e.preventDefault();
    setModalData({
      actionKey: 'reset',
      title: 'Reset file',
      description: '',
      actionType: 'single',
      item: {},
    });
    setOpenModal('confirm');
  }

  useEffect(() => {
    if (init) {
      fetchFile()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryString?.theme_id, queryString?.name]);

  useEffect(() => {
    getAllData()
    document.title = isEditTheme ? 'Edit theme file' : 'Theme preview';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading.page && !init) {
    return <Loader />;
  }

  if (!config?.access?.themes_files_edit || !queryString?.theme_id) {
    return <PageNotFound />
  }

  return (
    <div>
      <Grid fluid={isFullScreen}>
        <ModalsManager
          open={openModal}
          isLoading={isLoading.modal}
          isLoadingSubmit={isLoading.modalSubmit}
          modalData={modalData}
          onSubmit={onSubmitModal}
          onHide={onHideModals}
        />
        {error ? <AlertComponent text={error} />
          : (
            <div className="twig-list">
              {isLoading.page ? <div className="modal-loader-small" /> : null}
              <div className="twig-list__panel">
                <div className="twig-list__panel-header">
                  <div className="twig-list__panel-title">
                    <i onClick={onBack} title="Themes list" className="fas fa-chevron-left twig-list__panel-title-back" />
                    <span className="twig-list__panel-title-name">
                      {theme.name}
                    </span>
                    {' '}
                    templates
                  </div>
                </div>
                <div className="twig-list__panel-body">
                  <div className="twig-list__panel-list">
                    <TwigFilesList
                      isFullScreen={isFullScreen}
                      files={files}
                    />
                  </div>
                  <div className="twig-list__panel-content">
                    {errorForm ? (
                      <div className="twig-list__panel-alerts">
                        <AlertComponent type="danger" text={errorForm} />
                      </div>
                    ) : null }
                    <div className="twig-list__panel-code">
                      {isLoading.form && !isLoading.page
                        ? <div className="modal-loader-small" />
                        : null}
                      {isEditTheme
                        ? (
                          <div className="twig-list__panel-container">
                            <div className="twig-list__panel-files">
                              <TwigFileCode
                                onChange={setContent}
                                isFullScreen={isFullScreen}
                                onFullScreen={onFullScreen}
                                title={file.title}
                                filename={file.filename}
                                content={content}
                              />
                            </div>
                          </div>
                        )
                        : <AlertComponent type="info" text={('<div>Pick a file from the left sidebar to start editing.</div><div>Or <a href=\'/admin/docs\' class=\'twig-list__panel-content-docs-link\' target=\'_blank\'>click here</a> to learn more about editing templates.</div>')} />}
                    </div>
                    {isEditTheme ? (
                      <div className="twig-list__panel-footer">
                        <div />
                        <div className="twig-list__panel-footer-right">
                          {access?.reset && !isLoading.page ? (
                            <div>
                              <Button
                                disabled={isLoading.page || isLoading.form}
                                onClick={onReset}
                                bsStyle="link"
                                block
                              >
                                Reset File
                              </Button>
                            </div>
                          ) : null }
                          <div>
                            <Button
                              disabled={isLoading.page || isLoading.form}
                              onClick={onSaveChanges}
                              bsStyle="primary"
                              block
                            >
                              Save changes
                            </Button>
                          </div>
                        </div>
                      </div>
                    ) : null }
                  </div>

                </div>
              </div>
            </div>
          )}
      </Grid>
    </div>
  );
};

export default EditTwig;
